import { CREATE_NEW_RUN_MODAL_NAME } from '@neptune/onboarding-domain';
import { ModalHookOutput, useGenericModal } from '@neptune/shared/common-business-logic';

export const useCreateNewRunModal = (): ModalHookOutput<void> => {
  return useGenericModal(CREATE_NEW_RUN_MODAL_NAME);
};
